import {
  Avatar,
  Box,
  Button,
  Chip,
  Divider,
  Stack,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import useApi from "../hooks/useApi";

// Los artistas que representa un sello, manager o label, para quien mire su
// perfil: el propio sello en su pantalla, y el difusor cuando revisa uno de
// sus envíos y quiere saber a quién más mueve.
//
// Se pide siempre, sin preguntar antes de qué tipo es el perfil: el endpoint
// devuelve una lista vacía para los individuales y el componente no renderiza
// nada. Así ninguna vista necesita conocer la regla de familias.
export default function RosterPublico({
  userId,
  titulo = "Nuestros artistas",
  compacto = false,
  // Avisa cuántos artistas trajo, para que quien lo use pueda mostrar el
  // contador sin repetir la consulta.
  onCargado,
}) {
  const { loadApi } = useApi();
  const [artistas, setArtistas] = useState([]);

  useEffect(() => {
    if (!userId) return;
    loadApi(`general/roster/${userId}`, false, "get")
      .then((res) => {
        const lista = res.data?.artistas || [];
        setArtistas(lista);
        if (onCargado) onCargado(lista.length);
      })
      .catch(() => setArtistas([])); // sin roster no se muestra nada
  }, [userId]);

  if (artistas.length === 0) return null;

  return (
    <Stack component="section" gap={1.5}>
      <Typography variant="subtitle1">
        {titulo} ({artistas.length})
      </Typography>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: compacto
            ? "repeat(auto-fill, minmax(140px, 1fr))"
            : "repeat(auto-fill, minmax(180px, 1fr))",
          gap: 2,
        }}
      >
        {artistas.map((artista) => (
          <Stack key={artista.id} gap={0.5} alignItems="flex-start">
            <Stack direction="row" gap={1.5} alignItems="center" width="100%">
              <Avatar
                src={artista.imagen || undefined}
                variant="rounded"
                sx={{ width: compacto ? 40 : 56, height: compacto ? 40 : 56 }}
              >
                {artista.nombre?.[0]?.toUpperCase()}
              </Avatar>
              <Stack minWidth={0} flex={1}>
                <Typography variant="body2" fontWeight={600} noWrap>
                  {artista.nombre}
                </Typography>
                {artista.pais && (
                  <Box
                    component="img"
                    src={`https://flagcdn.com/${artista.pais}.svg`}
                    alt=""
                    sx={{ width: 18, height: 12, alignSelf: "flex-start" }}
                  />
                )}
              </Stack>
            </Stack>

            <Stack direction="row" gap={0.5} flexWrap="wrap">
              {(artista.generos_musicales || []).slice(0, 2).map((genero) => (
                <Chip key={genero} label={genero} size="small" />
              ))}
            </Stack>

            {artista.presskit && (
              <Button
                size="small"
                href={artista.presskit}
                target="_blank"
                rel="noreferrer"
                sx={{ px: 0, minWidth: 0 }}
              >
                Presskit
              </Button>
            )}
          </Stack>
        ))}
      </Box>
      <Divider />
    </Stack>
  );
}
